import jamespot from 'jamespot-user-api';

export async function fileSend(file: File, token: string | undefined, name: string) {
    const body = new FormData();

    body.append('attrName', name);
    body.append(name, file);
    if (token !== undefined) {
        body.append('token', token);
    }
    const res = await jamespot.network.postFile(body);
    return { result: res.response.result, token: res.token };
}
